import script from "./BetMyStakesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BetMyStakesTable.vue?vue&type=script&setup=true&lang=js"

import "./BetMyStakesTable.vue?vue&type=style&index=0&id=a3e70230&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3e70230"]])

export default __exports__